module.exports = __webpack_public_path__ + "img/18_70.43adff80.png";